import { OrderStatus } from '@src/core/buyerApiClient';

export const OrderCheckoutOutcome = {
  TariffExtraInfo: 'tariff-extra-info',
  OrderDetails: 'order-details',
  AwaitingConfirmation: 'awaiting-confirmation',
  Payment: 'payment',
} as const;

export type OrderCheckoutOutcome = (typeof OrderCheckoutOutcome)[keyof typeof OrderCheckoutOutcome];

interface Params {
  orderStatus: OrderStatus;
  hasPendingFormInputs: boolean;
}

export function resolveOrderCheckoutOutcome({ orderStatus, hasPendingFormInputs }: Params): OrderCheckoutOutcome {
  if (orderStatus === OrderStatus.AwaitingConfirmation) return OrderCheckoutOutcome.AwaitingConfirmation;
  if (hasPendingFormInputs) return OrderCheckoutOutcome.TariffExtraInfo;
  if (orderStatus === OrderStatus.Confirmed) return OrderCheckoutOutcome.OrderDetails;

  return OrderCheckoutOutcome.Payment;
}
